import {
  TextField,
  FormControlLabel,
  Checkbox,
  Select,
  MenuItem,
  Button,
  DialogActions,
  ThemeProvider,
  Dialog,
  DialogTitle,
  DialogContent,
  Collapse,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useMemo, useRef, useState } from "react";
import palette from "../../../../../../config/colorPalette";
import { clone, isEmpty, isNil } from "ramda";
import { handleChannelDisability } from "../utils";
import { getMuiTheme } from "../../../../../utils/utils";
import { MapContainer, Marker, Polyline, TileLayer, useMap } from "react-leaflet";
import { IS_ONLINE, MAP_TYPES } from "../../../../../../config/configmap";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ModalSectionInfo from "./modalSectionInfo";

const ModalChannelInfo = ({
  e,
  indChan,
  equipment,
  setEquipment,
  channelPK,
  equipmentInterMeasurement,
  setEquipmentInterMeasurement,
  zoneSubToggle,
  setZoneSubToggle,
  channelNameAsignToggle,
  channelDataToggle,
  setChannelDataToggle,
  zones,
  setZones,
  zoneToggle,
  setZoneToggle,
  setChannelNameAsignToggle,
  channelAsignToggle,
  setChannelAsignToggle,
  thresholdsRanges,
  indexEquipment,
  polylineDisplay,
  useStyles,
  setChannelPK,
  setThresholdsRanges,
  polylineColors,
  hoveredPolylineIndex,
  setHoveredPolylineIndex,
  moreSubsAllowed,
  centroid,
  customCentroidIcon,
  customInclinometerIcon,
  customIcon,
  customShadowIcon,
  inclinometers,
  open,
  errors,
  setErrors,
  BootstrapButton,
  intl,
}) => {
  const theme = useMemo(() => getMuiTheme(), []);
  const [mapType] = useState("regular");
  const initializedRef = useRef(false);
  const [substructureAsignToggle, setSubstructureAsignToggle] = useState(false);
  const [substructureDataToggle, setSubstructureDataToggle] = useState([]);
  const [substructureSectionToggle, setSubstructureSectionToggle] = useState([]);
  const [substructureSectionDataToggle, setSubstructureSectionDataToggle] = useState([]);

  useMemo(() => {
    const newEquipments = [...equipment];
    const updatedEquipment = { ...newEquipments[indexEquipment] };
    const actualLength = updatedEquipment.channels[indChan].substructures.length;

    const newSubAsign = [];
    const newSectionAsign = [];
    const newSectionDataAsign = [];
    for (let indexSub = 0; indexSub < actualLength; indexSub++) {
      if (isNil(substructureDataToggle[indexSub])) {
        newSubAsign.push(false);
      } else {
        newSubAsign.push(substructureDataToggle[indexSub]);
      }
      if (
        isNil(substructureSectionToggle[indexSub]) &&
        updatedEquipment.channels[indChan].substructures[indexSub].type === "inclinometer"
      ) {
        newSectionAsign.push(false);
      } else if (updatedEquipment.channels[indChan].substructures[indexSub].type === "inclinometer") {
        newSectionAsign.push(substructureSectionToggle[indexSub]);
      } else {
        newSectionAsign.push(null);
      }
      newSectionDataAsign.push([]);
      if (
        isNil(substructureSectionDataToggle[indexSub]) &&
        updatedEquipment.channels[indChan].substructures[indexSub].type === "inclinometer"
      ) {
        const secCount = updatedEquipment.channels[indChan].substructures[indexSub].sections.length;
        for (let indexSection = 0; indexSection < secCount; indexSection++) {
          newSectionDataAsign[indexSub].push(false);
        }
      } else if (updatedEquipment.channels[indChan].substructures[indexSub].type === "inclinometer") {
        const secCount = updatedEquipment.channels[indChan].substructures[indexSub].sections.length;
        for (let indexSection = 0; indexSection < secCount; indexSection++) {
          if (isNil(substructureSectionDataToggle[indexSub][indexSection])) {
            newSectionDataAsign[indexSub].push(false);
          } else {
            newSectionDataAsign[indexSub].push(substructureSectionDataToggle[indexSub][indexSection]);
          }
        }
      } else {
        newSectionDataAsign.push(null);
      }
    }
    setSubstructureSectionDataToggle(newSectionDataAsign);
    setSubstructureSectionToggle(newSectionAsign);
    setSubstructureDataToggle(newSubAsign);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClose = (indexEquipment, indChan, channelDataToggle, setChannelDataToggle) => {
    let newChannel = clone(channelDataToggle);
    if (newChannel[indexEquipment][indChan]) {
      newChannel[indexEquipment][indChan] = false;
    } else {
      initializedRef.current = false;
      newChannel[indexEquipment][indChan] = true;
      for (let indexChannelData = 0; indexChannelData < channelDataToggle[indexEquipment].length; indexChannelData++) {
        if (indexChannelData !== indChan) {
          newChannel[indexEquipment][indexChannelData] = false;
        }
      }
    }

    setChannelDataToggle(newChannel);
  };

  const MyComponentSetView = ({ polyline }) => {
    const map = useMap();
    if (!initializedRef.current && !isEmpty(polyline) && !isNil(polyline[0].points) && !isEmpty(polyline[0].points)) {
      map.fitBounds(polyline[0].points);
      initializedRef.current = true;
    }
    return null;
  };
  return (
    <>
      <Button
        variant="contained"
        style={{ margin: "5%", backgroundColor: palette.secondary, color: "white" }}
        id={`channel${indChan}_collapse`}
        onClick={() => {
          handleClose(indexEquipment, indChan, channelDataToggle, setChannelDataToggle);
        }}
      >
        {intl.formatMessage({ id: "channel" })} {indChan + 1}
      </Button>
      <ThemeProvider theme={theme}>
        <Dialog
          maxWidth="lg"
          open={channelDataToggle[indexEquipment][indChan]}
          onClose={() => handleClose(indexEquipment, indChan, channelDataToggle, setChannelDataToggle)}
        >
          <DialogTitle style={{ fontSize: "x-large", color: palette.primary, fontWeight: "600" }}>
            {intl.formatMessage({ id: "channel" })} {indChan + 1}
          </DialogTitle>
          <DialogContent>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "20px",
                width: "100%",
                boxSizing: "border-box",
                overflowX: "hidden", // evita scroll horizontal
                alignItems: "flex-start",
              }}
            >
              <div
                style={{
                  flex: "0 0 60%", // ocupa 60% del ancho
                  display: "flex",
                  flexDirection: "column",
                  gap: "1rem",
                  boxSizing: "border-box",
                  minWidth: 0, // importante para que los hijos flex no provoquen overflow
                  paddingRight: "8px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                    gap: "0.5rem",
                    alignItems: "center",
                    width: "100%",
                    boxSizing: "border-box",
                    marginTop: "1%",
                  }}
                >
                  <TextField
                    id={`channel_name_${indChan}`}
                    style={{ margin: "0 0.2rem 0.8rem", minWidth: 0, flex: "1 1 220px" }}
                    defaultValue={""}
                    value={e.channels[indChan].name}
                    onChange={(ev) => {
                      const newEquipments = [...equipment];
                      const updatedEquipment = { ...newEquipments[indexEquipment] };
                      updatedEquipment.channels[indChan].name = ev.target.value;
                      newEquipments[indexEquipment] = updatedEquipment;
                      setEquipment(newEquipments);
                    }}
                    error={errors[`channel_name_${indChan}`] ? true : false}
                    variant="outlined"
                    label={intl.formatMessage({ id: "channel.name" })}
                    required
                  />

                  <TextField
                    id={`channel_length_${indChan}`}
                    style={{ margin: "0 0.2rem 0.8rem", width: "150px", minWidth: 0 }}
                    inputProps={{ min: 0 }}
                    defaultValue={channelPK[indexEquipment][indChan]}
                    value={channelPK[indexEquipment][indChan]}
                    disabled={true}
                    onChange={(ev) => {
                      const newEquipments = [...equipment];
                      const updatedEquipment = { ...newEquipments[indexEquipment] };
                      updatedEquipment.channels[indChan].info.length = parseFloat(ev.target.value);
                      newEquipments[indexEquipment] = updatedEquipment;
                      setEquipment(newEquipments);
                    }}
                    error={errors[`channel_length_${indChan}`] ? true : false}
                    variant="outlined"
                    label={intl.formatMessage({ id: "channel.length" })}
                    type="number"
                    required
                  />

                  {e.equipmentType !== "DAS" && (
                    <TextField
                      id={`channel_spatial_resolution_${indChan}`}
                      style={{ margin: "0 0.2rem 0.8rem", width: "150px", minWidth: 0 }}
                      inputProps={{ min: 0 }}
                      defaultValue={0}
                      value={e.channels[indChan].info.spatialResolution}
                      onChange={(ev) => {
                        const newEquipments = [...equipment];
                        const updatedEquipment = { ...newEquipments[indexEquipment] };
                        updatedEquipment.channels[indChan].info.spatialResolution = parseFloat(ev.target.value);
                        newEquipments[indexEquipment] = updatedEquipment;
                        setEquipment(newEquipments);
                      }}
                      error={errors[`channel_spatial_resolution_${indChan}`] ? true : false}
                      variant="outlined"
                      label={intl.formatMessage({ id: "channel.spatial.resolution" })}
                      required
                      type="number"
                    />
                  )}

                  <TextField
                    id={`channel_sampling_interval_${indChan}`}
                    style={{ margin: "0 0.2rem 0.8rem", width: "150px", minWidth: 0 }}
                    inputProps={{ min: 0 }}
                    defaultValue={0}
                    value={e.channels[indChan].info.samplingInterval}
                    onChange={(ev) => {
                      const newEquipments = [...equipment];
                      const updatedEquipment = { ...newEquipments[indexEquipment] };
                      updatedEquipment.channels[indChan].info.samplingInterval = parseFloat(ev.target.value);
                      newEquipments[indexEquipment] = updatedEquipment;
                      setEquipment(newEquipments);
                    }}
                    error={errors[`channel_sampling_interval_${indChan}`] ? true : false}
                    variant="outlined"
                    label={intl.formatMessage({ id: "channel.sampling.interval" })}
                    required
                    type="number"
                  />

                  {e.equipmentType !== "DAS" && (
                    <TextField
                      id={`channel_measurement_time_${indChan}`}
                      style={{ margin: "0 0.2rem 0.8rem", width: "150px", minWidth: 0 }}
                      defaultValue={0}
                      value={e.channels[indChan].measurement.measurementTime}
                      inputProps={{ min: 0 }}
                      onChange={(ev) => {
                        const newEquipments = [...equipment];
                        const updatedEquipment = { ...newEquipments[indexEquipment] };
                        updatedEquipment.channels[indChan].measurement.measurementTime = parseFloat(ev.target.value);
                        const suma = updatedEquipment.channels.reduce(
                          (acumulador, canal) => acumulador + (parseFloat(canal.measurement.measurementTime) || 0),
                          0,
                        );
                        updatedEquipment.measurementInfo.interval = suma;
                        newEquipments[indexEquipment] = updatedEquipment;
                        setEquipment(newEquipments);

                        let newInter = clone(equipmentInterMeasurement);
                        newInter[indexEquipment] = suma;
                        setEquipmentInterMeasurement(newInter);
                      }}
                      error={errors[`channel_measurement_time_${indChan}`] ? true : false}
                      variant="outlined"
                      label={intl.formatMessage({ id: "channel.measurement.time" })}
                      required
                      type="number"
                    />
                  )}

                  {e.equipmentType === "DAS" && (
                    <>
                      <TextField
                        id={`channel_acquisition_frequency_${indChan}`}
                        style={{ margin: "0 0.2rem 0.8rem", width: "150px", minWidth: 0 }}
                        defaultValue={0}
                        value={e.channels[indChan].info.acquisitionFrequency}
                        inputProps={{ min: 0 }}
                        onChange={(ev) => {
                          const newEquipments = [...equipment];
                          const updatedEquipment = { ...newEquipments[indexEquipment] };
                          updatedEquipment.channels[indChan].info.acquisitionFrequency = parseFloat(ev.target.value);
                          newEquipments[indexEquipment] = updatedEquipment;
                          setEquipment(newEquipments);
                        }}
                        error={errors[`channel_acquisition_frequency_${indChan}`] ? true : false}
                        variant="outlined"
                        label={intl.formatMessage({ id: "channel.acquisition.frequency" })}
                        required
                        type="number"
                      />
                      <TextField
                        id={`channel_gauge_length_${indChan}`}
                        style={{ margin: "0 0.2rem 0.8rem", width: "150px", minWidth: 0 }}
                        defaultValue={0}
                        value={e.channels[indChan].info.gaugeLength}
                        inputProps={{ min: 0 }}
                        onChange={(ev) => {
                          const newEquipments = [...equipment];
                          const updatedEquipment = { ...newEquipments[indexEquipment] };
                          updatedEquipment.channels[indChan].info.gaugeLength = parseFloat(ev.target.value);
                          newEquipments[indexEquipment] = updatedEquipment;
                          setEquipment(newEquipments);
                        }}
                        error={errors[`channel_acquisition_frequency_${indChan}`] ? true : false}
                        variant="outlined"
                        label={intl.formatMessage({ id: "channel.gauge.length" })}
                        required
                        type="number"
                      />
                    </>
                  )}

                  <div style={{ marginLeft: "auto", minWidth: 0 }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          id={"checkbox" + indChan}
                          sx={{
                            color: palette.primary,
                            "&.Mui-checked": {
                              color: palette.primary,
                            },
                          }}
                          defaultChecked={e.channels[indChan].measurement.state}
                          onChange={(ev) => {
                            handleChannelDisability({
                              actualID: equipment + indexEquipment + "_frequency",
                              equipment,
                              equipmentInterMeasurement,
                              errors,
                              indChan,
                              indexEquipment,
                              newState: ev.target.checked,
                              setEquipment,
                              setEquipmentInterMeasurement,
                              setErrors,
                            });
                          }}
                        />
                      }
                      label={intl.formatMessage({ id: "disable?" })}
                    />
                  </div>

                  {e.channels[indChan].state ? (
                    <TextField
                      id={`channel_info_${indChan}`}
                      style={{ margin: "0 0.2rem 0.8rem", minWidth: 0, flex: "1 1 300px" }}
                      inputProps={{ min: 0 }}
                      value={e.channels[indChan].info.desc || e.channels[indChan].info}
                      onChange={(ev) => {
                        const newEquipments = [...equipment];
                        const updatedEquipment = { ...newEquipments[indexEquipment] };
                        updatedEquipment.channels[indChan].info.desc = ev.target.value;
                        newEquipments[indexEquipment] = updatedEquipment;
                        setEquipment(newEquipments);
                      }}
                      error={errors[`channel_info_${indChan}`] ? true : false}
                      variant="outlined"
                      label={intl.formatMessage({ id: "channel.info" })}
                    />
                  ) : null}
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "0.75rem",
                    width: "100%",
                    boxSizing: "border-box",
                  }}
                >
                  <TextField
                    id={`sub_quantity${indChan}`}
                    style={{ margin: "0 0.2rem 0.8rem", width: "150px", minWidth: 0 }}
                    defaultValue={e.channels[indChan].substructures.length}
                    value={e.channels[indChan].substructures.length}
                    inputProps={{ min: 0 }}
                    onChange={(ev) => {
                      const newEquipments = [...equipment];
                      const updatedEquipment = { ...newEquipments[indexEquipment] };
                      let newZoneSubToggle = clone(zoneSubToggle);
                      newZoneSubToggle[indexEquipment][indChan] = [];
                      let newZoneToggle = clone(zoneToggle);
                      const newLength = parseInt(ev.target.value);
                      const actualLength = updatedEquipment.channels[indChan].substructures.length;
                      if (newLength > actualLength) {
                        for (let i = actualLength; i < newLength; i++) {
                          if (!isEmpty(polylineDisplay) && !moreSubsAllowed) {
                            updatedEquipment.channels[indChan].substructures.push({
                              name: "",
                              type: "generic",
                              polyline: 0,
                              depth: null,
                              sections: null,
                              zones: [],
                            });
                          } else {
                            updatedEquipment.channels[indChan].substructures.push({
                              name: "",
                              type: "inclinometer",
                              polyline: [0, 0],
                              depth: 50,
                              sections: [""],
                              zones: [],
                            });
                          }
                        }
                      } else {
                        updatedEquipment.channels[indChan].substructures.splice(newLength);
                      }
                      const newSubAsign = [];
                      const newSectionAsign = [];
                      const newSectionDataAsign = [];
                      let newZones = clone(zones);

                      const eqKey = `equipment${indexEquipment + 1}`;
                      const chKey = `channel${indChan + 1}`;

                      newZones[eqKey] ??= {};
                      newZones[eqKey][chKey] ??= {};
                      for (let indexSub = 0; indexSub < newLength; indexSub++) {
                        newZoneSubToggle[indexEquipment][indChan].push(false);
                        if (isNil(zoneToggle[indexEquipment]?.[indChan]?.[indexSub])) {
                          newZoneToggle[indexEquipment] ??= [];
                          newZoneToggle[indexEquipment][indChan].push([]);
                          newZoneToggle[indexEquipment][indChan][indexSub].push([false]);
                        }

                        const subKey = `sub${indexSub + 1}`;
                        const oldValue = newZones[eqKey][chKey][subKey];

                        if (isNil(oldValue)) {
                          newZones[eqKey][chKey][subKey] = [{ ini: 0, end: 10, alertsConfigurations: null }];
                        } else {
                          newZones[eqKey][chKey][subKey] = clone(oldValue);
                        }

                        if (isNil(substructureDataToggle[indexSub])) {
                          newSubAsign.push(false);
                        } else {
                          newSubAsign.push(substructureDataToggle[indexSub]);
                        }
                        if (
                          isNil(substructureSectionToggle[indexSub]) &&
                          updatedEquipment.channels[indChan].substructures[indexSub].type === "inclinometer"
                        ) {
                          newSectionAsign.push(false);
                        } else if (updatedEquipment.channels[indChan].substructures[indexSub].type === "inclinometer") {
                          newSectionAsign.push(substructureSectionToggle[indexSub]);
                        } else {
                          newSectionAsign.push(null);
                        }
                        newSectionDataAsign.push([]);
                        if (
                          isNil(substructureSectionDataToggle[indexSub]) &&
                          updatedEquipment.channels[indChan].substructures[indexSub].type === "inclinometer"
                        ) {
                          const secCount = updatedEquipment.channels[indChan].substructures[indexSub].sections.length;
                          for (let indexSection = 0; indexSection < secCount; indexSection++) {
                            newSectionDataAsign[indexSub].push(false);
                          }
                        } else if (updatedEquipment.channels[indChan].substructures[indexSub].type === "inclinometer") {
                          const secCount = updatedEquipment.channels[indChan].substructures[indexSub].sections.length;
                          for (let indexSection = 0; indexSection < secCount; indexSection++) {
                            if (isNil(substructureSectionDataToggle[indexSub][indexSection])) {
                              newSectionDataAsign[indexSub].push(false);
                            } else {
                              newSectionDataAsign[indexSub].push(substructureSectionDataToggle[indexSub][indexSection]);
                            }
                          }
                        } else {
                          newSectionDataAsign.push(null);
                        }
                      }

                      if (newZoneToggle[indexEquipment] && newZoneToggle[indexEquipment][indChan]) {
                        newZoneToggle[indexEquipment][indChan] = newZoneToggle[indexEquipment][indChan].slice(
                          0,
                          newLength,
                        );
                      }

                      const channel = newZones[eqKey]?.[chKey];
                      if (channel) {
                        Object.keys(channel).forEach((subKey) => {
                          const subIndex = parseInt(subKey.replace("sub", ""), 10);
                          if (subIndex > newLength) {
                            delete channel[subKey];
                          }
                        });
                      }

                      setZones(newZones);
                      setZoneToggle(newZoneToggle);
                      setZoneSubToggle(newZoneSubToggle);
                      setSubstructureSectionDataToggle(newSectionDataAsign);
                      setSubstructureSectionToggle(newSectionAsign);
                      setSubstructureDataToggle(newSubAsign);
                      newEquipments[indexEquipment] = updatedEquipment;
                      setEquipment(newEquipments);
                    }}
                    error={errors[`channel_acquisition_frequency_${indChan}`] ? true : false}
                    variant="outlined"
                    label={intl.formatMessage({ id: "sub.count" })}
                    required
                    type="number"
                  />
                  <BootstrapButton
                    variant="contained"
                    style={{ margin: "0.5rem 0.2rem 0.8rem" }}
                    id="substructures-to-channels"
                    onClick={() => {
                      let newChannel = clone(substructureAsignToggle);
                      if (newChannel) {
                        newChannel = false;
                      } else {
                        newChannel = true;
                      }
                      setSubstructureAsignToggle(newChannel);
                    }}
                  >
                    {intl.formatMessage({ id: "substructures.to.polylines" })}
                    {!substructureAsignToggle ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
                  </BootstrapButton>
                  <Collapse in={substructureAsignToggle}>
                    {e.channels[indChan].substructures.map((sub, indSub) => {
                      return (
                        <>
                          <h1
                            style={{ marginRight: "1%" }}
                            id={`sub${indSub}_collapse`}
                            onClick={() => {
                              let newChannel = clone(substructureDataToggle);
                              if (newChannel[indSub]) {
                                newChannel[indSub] = false;
                              } else {
                                newChannel[indSub] = true;
                              }
                              setSubstructureDataToggle(newChannel);
                            }}
                          >
                            {intl.formatMessage({ id: "sub" })} {indSub + 1}
                            {!substructureDataToggle[indSub] ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
                          </h1>
                          <Collapse in={substructureDataToggle[indSub]}>
                            <div
                              key={`substructure_${indSub}`}
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                gap: "0.5rem",
                                width: "100%",
                                boxSizing: "border-box",
                                marginTop: "2%",
                              }}
                            >
                              <Tooltip
                                title={
                                  <React.Fragment>
                                    <Typography color="inherit">{intl.formatMessage({ id: "sub.name" })}</Typography>
                                  </React.Fragment>
                                }
                              >
                                <TextField
                                  id={`sub_name_${indSub}`}
                                  style={{ width: "15rem", minWidth: 0 }}
                                  value={e.channels[indChan].substructures[indSub].name}
                                  onChange={(ev) => {
                                    const newEquipments = [...equipment];
                                    const updatedEquipment = { ...newEquipments[indexEquipment] };
                                    updatedEquipment.channels[indChan].substructures[indSub].name = ev.target.value;
                                    newEquipments[indexEquipment] = updatedEquipment;
                                    setEquipment(newEquipments);
                                  }}
                                  error={errors[`sub_name_${indSub}`] ? true : false}
                                  variant="outlined"
                                  label={intl.formatMessage({ id: "sub.name" })}
                                  required
                                />
                              </Tooltip>

                              <Tooltip
                                title={
                                  <React.Fragment>
                                    <Typography color="inherit">{intl.formatMessage({ id: "sub.type" })}</Typography>
                                  </React.Fragment>
                                }
                              >
                                <TextField
                                  id={`sub_type_${indSub}`}
                                  variant="outlined"
                                  disabled={!moreSubsAllowed}
                                  style={{ width: "15rem", minWidth: 0 }}
                                  label={intl.formatMessage({ id: "sub.type" })}
                                  value={e.channels[indChan].substructures[indSub].type}
                                  select
                                  onChange={(ev) => {
                                    const newEquipments = [...equipment];
                                    const updatedEquipment = { ...newEquipments[indexEquipment] };
                                    updatedEquipment.channels[indChan].substructures[indSub].type = ev.target.value;
                                    const polyNumber =
                                      updatedEquipment.channels[indChan].substructures[indSub].polyline;
                                    if (ev.target.value === "generic" && !Number.isInteger(polyNumber)) {
                                      updatedEquipment.channels[indChan].substructures[indSub].polyline = 0;
                                      updatedEquipment.channels[indChan].substructures[indSub].depth = null;
                                      updatedEquipment.channels[indChan].substructures[indSub].sections = null;
                                    } else if (ev.target.value === "inclinometer" && Number.isInteger(polyNumber)) {
                                      updatedEquipment.channels[indChan].substructures[indSub].polyline = [0, 0];
                                      updatedEquipment.channels[indChan].substructures[indSub].depth = 50;
                                      updatedEquipment.channels[indChan].substructures[indSub].sections = [""];
                                    }
                                    newEquipments[indexEquipment] = updatedEquipment;
                                    setEquipment(newEquipments);
                                  }}
                                  error={errors["measure" + indexEquipment] ? true : false}
                                  required
                                >
                                  {!isEmpty(polylineDisplay) && (
                                    <MenuItem key={`sub_type_${indSub}_generic`} value={"generic"}>
                                      Generic
                                    </MenuItem>
                                  )}
                                  {moreSubsAllowed && (
                                    <MenuItem key={`sub_type_${indSub}_inclinometer`} value={"inclinometer"}>
                                      Inclinometer
                                    </MenuItem>
                                  )}
                                </TextField>
                              </Tooltip>

                              {e.channels[indChan].substructures[indSub].type === "inclinometer" && (
                                <Tooltip
                                  title={
                                    <React.Fragment>
                                      <Typography color="inherit">
                                        {intl.formatMessage({ id: "sub.section" })}
                                      </Typography>
                                    </React.Fragment>
                                  }
                                >
                                  <TextField
                                    id={`sub_sectioncount_${indSub}`}
                                    style={{ width: "12rem", minWidth: 0 }}
                                    defaultValue={e.channels[indChan].substructures[indSub].sections.length}
                                    inputProps={{ min: 1 }}
                                    onChange={(ev) => {
                                      const newEquipments = [...equipment];
                                      const updatedEquipment = { ...newEquipments[indexEquipment] };
                                      const newSection = [];
                                      for (
                                        let indexSection = 0;
                                        indexSection < parseInt(ev.target.value).length;
                                        indexSection++
                                      ) {
                                        if (
                                          isNil(
                                            updatedEquipment.channels[indChan].substructures[indSub].sections[
                                              indexSection
                                            ],
                                          )
                                        ) {
                                          newSection.push("");
                                        } else {
                                          newSection.push(
                                            updatedEquipment.channels[indChan].substructures[indSub].sections[
                                              indexSection
                                            ],
                                          );
                                        }
                                      }
                                      updatedEquipment.channels[indChan].substructures[indSub].sections = newSection;
                                      newEquipments[indexEquipment] = updatedEquipment;
                                      setEquipment(newEquipments);
                                    }}
                                    type="number"
                                    error={errors[`sub_sectioncount_${indSub}`] ? true : false}
                                    variant="outlined"
                                    label={intl.formatMessage({ id: "sub.section" })}
                                    required
                                  />
                                </Tooltip>
                              )}

                              {/* Polyline select OR lat/lon inputs */}
                              {e.channels[indChan].substructures[indSub].type === "generic" ? (
                                <Select
                                  id={e.equipmentID + "channel" + indChan + "_poly"}
                                  label={intl.formatMessage({ id: "polyline" })}
                                  onChange={(ev) => {
                                    const newEquipments = [...equipment];
                                    const updatedEquipment = { ...newEquipments[indexEquipment] };
                                    updatedEquipment.channels[indChan].substructures[indSub].polyline = parseInt(
                                      ev.target.value,
                                    );
                                    newEquipments[indexEquipment] = updatedEquipment;
                                    setHoveredPolylineIndex(null);
                                    setEquipment(newEquipments);
                                  }}
                                  defaultValue={e.channels[indChan].substructures[indSub].polyline}
                                  onMouseOut={() => {
                                    setHoveredPolylineIndex(null);
                                  }}
                                  style={{ width: "6rem", minWidth: 0 }}
                                >
                                  {polylineDisplay.map((p, indPoly) => {
                                    if (p.equipment_type !== e.equipmentType) return null;
                                    return (
                                      <MenuItem
                                        key={e.equipmentID + "channel" + indChan + "_" + indPoly}
                                        value={indPoly}
                                        onMouseOver={() => {
                                          setHoveredPolylineIndex(null);
                                          setTimeout(() => {
                                            setHoveredPolylineIndex(indPoly);
                                          }, 0);
                                        }}
                                        onMouseOut={() => {
                                          setHoveredPolylineIndex(null);
                                        }}
                                      >
                                        {p.id}
                                      </MenuItem>
                                    );
                                  })}
                                </Select>
                              ) : (
                                <div style={{ display: "flex", gap: "0.5rem" }}>
                                  <TextField
                                    id={`section_depth_${indChan}_${indSub}`}
                                    style={{ width: "5.5rem", minWidth: 0 }}
                                    inputProps={{ min: 0 }}
                                    defaultValue={0}
                                    value={e.channels[indChan].substructures[indSub].depth}
                                    onChange={(ev) => {
                                      const newEquipments = [...equipment];
                                      const updatedEquipment = { ...newEquipments[indexEquipment] };
                                      if (!Number.isNaN(parseFloat(ev.target.value)) && !isNil(ev.target.value)) {
                                        updatedEquipment.channels[indChan].substructures[indSub].depth = parseFloat(
                                          ev.target.value,
                                        );
                                      }
                                      newEquipments[indexEquipment] = updatedEquipment;
                                      setEquipment(newEquipments);
                                    }}
                                    variant="outlined"
                                    label={intl.formatMessage({ id: "depth" })}
                                    required
                                    type="number"
                                  />
                                  <TextField
                                    id={`sub_lat_${indSub}`}
                                    style={{ width: "6.5rem", minWidth: 0 }}
                                    defaultValue={e.channels[indChan].substructures[indSub].polyline[0]}
                                    inputProps={{ min: -180, max: 180 }}
                                    onChange={(ev) => {
                                      const newEquipments = [...equipment];
                                      const updatedEquipment = { ...newEquipments[indexEquipment] };
                                      if (!Number.isNaN(parseFloat(ev.target.value)) && !isNil(ev.target.value)) {
                                        updatedEquipment.channels[indChan].substructures[indSub].polyline[0] =
                                          parseFloat(ev.target.value);
                                      }
                                      newEquipments[indexEquipment] = updatedEquipment;
                                      setEquipment(newEquipments);
                                    }}
                                    type="number"
                                    error={errors[`sub_lat_${indSub}`] ? true : false}
                                    variant="outlined"
                                    label={intl.formatMessage({ id: "latitude" })}
                                    required
                                  />
                                  <TextField
                                    id={`sub_lon_${indSub}`}
                                    style={{ width: "6.5rem", minWidth: 0 }}
                                    defaultValue={e.channels[indChan].substructures[indSub].polyline[1]}
                                    inputProps={{ min: -180, max: 180 }}
                                    onChange={(ev) => {
                                      const newEquipments = [...equipment];
                                      const updatedEquipment = { ...newEquipments[indexEquipment] };
                                      if (!Number.isNaN(parseFloat(ev.target.value)) && !isNil(ev.target.value)) {
                                        updatedEquipment.channels[indChan].substructures[indSub].polyline[1] =
                                          parseFloat(ev.target.value);
                                      }
                                      newEquipments[indexEquipment] = updatedEquipment;
                                      setEquipment(newEquipments);
                                    }}
                                    type="number"
                                    error={errors[`sub_lon_${indSub}`] ? true : false}
                                    variant="outlined"
                                    label={intl.formatMessage({ id: "longitude" })}
                                    required
                                  />
                                </div>
                              )}
                            </div>
                            {e.channels[indChan].substructures[indSub].type === "inclinometer" && (
                              <BootstrapButton
                                variant="contained"
                                style={{ margin: "0.5rem 0.2rem 0.8rem" }}
                                id="substructures-to-channels"
                                onClick={() => {
                                  let newSection = clone(substructureSectionToggle);
                                  if (newSection[indSub]) {
                                    newSection[indSub] = false;
                                  } else {
                                    newSection[indSub] = true;
                                  }
                                  setSubstructureSectionToggle(newSection);
                                }}
                              >
                                {intl.formatMessage({ id: "sections" })}
                                {!substructureSectionToggle[indSub] ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
                              </BootstrapButton>
                            )}
                            <Collapse in={substructureSectionToggle[indSub]}>
                              {e.channels[indChan].substructures[indSub].type === "inclinometer" &&
                                e.channels[indChan].substructures[indSub].sections.map((section, indexSection) => {
                                  return (
                                    <>
                                      <Button
                                        variant="contained"
                                        style={{ margin: "5%", backgroundColor: palette.secondary, color: "white" }}
                                        id={`collapseSub${indSub}_${indexSection}`}
                                        onClick={() => {
                                          let newA = clone(substructureSectionDataToggle);
                                          newA[indSub][indexSection] = true;
                                          setSubstructureSectionDataToggle(newA);
                                        }}
                                      >
                                        {intl.formatMessage({ id: "section" })} {indChan + 1}
                                      </Button>
                                      <ModalSectionInfo
                                        e={e}
                                        equipment={equipment}
                                        indexEquipment={indexEquipment}
                                        setEquipment={setEquipment}
                                        key={`collapse_form_Sub${indSub}_${indexSection}`}
                                        indChan={indChan}
                                        indSub={indSub}
                                        indexSection={indexSection}
                                        substructureSectionDataToggle={substructureSectionDataToggle}
                                        setSubstructureSectionDataToggle={setSubstructureSectionDataToggle}
                                        intl={intl}
                                      />
                                    </>
                                  );
                                })}
                            </Collapse>
                          </Collapse>
                        </>
                      );
                    })}
                  </Collapse>
                </div>
              </div>

              <div
                style={{
                  flex: "0 0 40%", // ocupa el 40% restante
                  minWidth: "320px",
                  boxSizing: "border-box",
                  height: "calc(100vh - 320px)",
                }}
              >
                <MapContainer
                  id="map-equipment-id"
                  center={[43, 0]}
                  zoom={5}
                  style={{ height: "100%", width: "100%" }}
                  anima
                >
                  <TileLayer
                    attribution={IS_ONLINE ? "Google Maps" : "OpenStreetMap"}
                    url={MAP_TYPES.find((type) => type.value === mapType).tileLayer}
                    maxZoom={20}
                    subdomains={["mt0", "mt1", "mt2", "mt3"]}
                  />
                  {centroid.length > 0 && (
                    <Marker key={"Centroid"} position={centroid} icon={customCentroidIcon}></Marker>
                  )}
                  <MyComponentSetView polyline={polylineDisplay} />
                  {/* polylines / markers (misma lógica tua) */}
                  {isNil(hoveredPolylineIndex) &&
                    polylineDisplay.length > 0 &&
                    polylineDisplay.map((polyline, index) => {
                      if (polyline.equipment_type !== e.equipmentType) return null;
                      let color = "black";
                      // eslint-disable-next-line array-callback-return
                      return polyline.points.map((point, indice) => {
                        if (indice === 0 || polyline.must_graph_points.indexOf(indice) === 0) return null;
                        if (polyline.must_graph_points.includes(indice)) {
                          const previousIndex =
                            polyline.must_graph_points[polyline.must_graph_points.indexOf(indice) - 1];
                          const center = [
                            [
                              polylineDisplay[index].points[previousIndex].lat,
                              polylineDisplay[index].points[previousIndex].lng,
                            ],
                            [point.lat, point.lng],
                          ];
                          for (let indexSub = 0; indexSub < e.channels[indChan].substructures.length; indexSub++) {
                            if (index === e.channels[indChan].substructures[indexSub].polyline) {
                              color = "red";
                            }
                          }
                          return <Polyline key={indice + "_" + index} color={color} positions={center} weight={5} />;
                        }
                      });
                    })}

                  {!isNil(hoveredPolylineIndex) &&
                    polylineDisplay.length > 0 &&
                    polylineDisplay.map((polyline, index) => {
                      if (polyline.equipment_type !== e.equipmentType) return null;
                      let color = "black";
                      // eslint-disable-next-line array-callback-return
                      return polyline.points.map((point, indice) => {
                        if (indice === 0 || polyline.must_graph_points.indexOf(indice) === 0) return null;
                        if (polyline.must_graph_points.includes(indice)) {
                          const previousIndex =
                            polyline.must_graph_points[polyline.must_graph_points.indexOf(indice) - 1];
                          const center = [
                            [
                              polylineDisplay[index].points[previousIndex].lat,
                              polylineDisplay[index].points[previousIndex].lng,
                            ],
                            [point.lat, point.lng],
                          ];
                          for (let indexSub = 0; indexSub < e.channels[indChan].substructures.length; indexSub++) {
                            if (index === e.channels[indChan].substructures[indexSub].polyline) {
                              color = "red";
                            }
                          }
                          return (
                            <Polyline
                              key={indice + "_" + index}
                              color={hoveredPolylineIndex === index ? "#0dff00" : color}
                              positions={center}
                              weight={hoveredPolylineIndex === index ? 9 : 5}
                            />
                          );
                        }
                      });
                    })}

                  {equipment.length > 0 &&
                    equipment.map((equip, index) => (
                      <Marker
                        key={"equipment" + index}
                        position={[equip.latitude, equip.longitude]}
                        icon={open[index] ? customShadowIcon : customIcon}
                      />
                    ))}

                  {inclinometers.length > 0 &&
                    inclinometers.map((im, index) => (
                      <Marker key={"inclinometer" + index + im} position={im} icon={customInclinometerIcon} />
                    ))}
                </MapContainer>
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              style={{ backgroundColor: palette.secondary, color: "white" }}
              onClick={() => handleClose(indexEquipment, indChan, channelDataToggle, setChannelDataToggle)}
            >
              {intl.formatMessage({ id: "accept" })}
            </Button>
          </DialogActions>
        </Dialog>
      </ThemeProvider>
    </>
  );
};

export default ModalChannelInfo;
